import { useSortBy } from "react-instantsearch";

import { ProductSort as ProductSortUi } from "@/stf.ui/ui.product-sort";

import { useProductListContext } from "../feat.product-list-context";

const ProductSort = () => {
  const { sortByItems } = useProductListContext();

  const {
    currentRefinement,
    refine,
    options,
  } = useSortBy({
    items: sortByItems,
  });

  return (
    <ProductSortUi
      sortByChoices={options}
      sortBy={currentRefinement}
      setSortBy={(v) => { refine(v); }}
    />
  );
};

export { ProductSort };
